import React from 'react';
import { connect } from 'react-redux';
import { Table } from 'reactstrap';
import { prepareNum, unitLabel } from '@services/helper.service';
import { APP_TEXTS } from '../../../../../texts/texts';

import './../styles.scss';

class ResultsOfDesignCSA extends React.Component {

	constructor(props) {
		super(props);

		this.prepareValue = props.prepareValue;
	}

	render() {
		return (
		<div className="calculation">
				{this.props.selectedItem && (
				<section className="list-type calculate-results-of-design">
				<Table bordered size="sm">
						<thead>
						<tr>
								<th>{APP_TEXTS.CALCULATE_RESULTS_DESIGN_TENSION.Content}</th>
								<th>{unitLabel(this.props.loadUnit)}</th>
								<th>&beta;<sub>N</sub>&nbsp;=</th>
						</tr>
						</thead>
						<tbody>
						<tr>
								<th scope="row">
								<div className="d-flex">
										<span>{APP_TEXTS.CALCULATE_RESULTS_DESIGN_CONCRETE_BREAKOUT.Content}</span>
										<span>N<sub>cb{!this.props.hasSingleAnchor && ('g')}r</sub></span>
								</div>
								</th>
										<td>
											{this.prepareValue(this.props.hasSingleAnchor ? 
												this.props.selectedItem.Ncbr : 
												this.props.selectedItem.Ncbgr)}
										</td>
										<td>{prepareNum(this.props.selectedItem.BetaN_ConcreteConeFailure, true, 2, true)}</td>
						</tr>
						<tr>
								<th scope="row">
								<div className="d-flex">
										<span>{APP_TEXTS.CALCULATE_RESULTS_DESIGN_STEEL_STRENGTH.Content}</span>
										<span>N<sub>sar</sub></span>
								</div>
								</th>
										<td>{this.prepareValue(this.props.selectedItem.Nsar)}</td>
										<td>{prepareNum(this.props.selectedItem.BetaN_SteelFailure, true, 2, true)}</td>
						</tr>
						<tr>
								<th scope="row">
								<div className="d-flex">
										<span>
											{this.props.selectedItem.IsChemical ? 
												APP_TEXTS.CALCULATE_RESULTS_DESIGN_BOND_STRENGTH.Content :
												APP_TEXTS.CALCULATE_RESULTS_DESIGN_PULLOUT_STRENGTH.Content}
											</span>
										<span>
                      N
											<sub>
												{this.props.selectedItem.IsChemical ? (this.props.hasSingleAnchor ? 'ar' : 'agr') : 'cpr'}
											</sub>
										</span>
								</div>
								</th>
										<td>
											{this.prepareValue(this.props.selectedItem.IsChemical ? 
												(this.props.hasSingleAnchor ? 
													this.props.selectedItem.Nar : 
													this.props.selectedItem.Nagr
												) :
												this.props.selectedItem.Ncpr)}
										</td>
										<td>
											{prepareNum(this.props.selectedItem.IsChemical ? 
												this.props.selectedItem.BetaN_BondFailure : 
												this.props.selectedItem.BetaN_PullOutFailure, true, 2, true)}
										</td>
						</tr>
						</tbody>
				</Table>
		
				<Table bordered size="sm">
						<thead>
						<tr>
								<th>{APP_TEXTS.CALCULATE_HEADER_SHEAR.Content}</th>
								<th>{unitLabel(this.props.loadUnit)}</th>
								<th>&beta;<sub>V</sub>&nbsp;=</th>
						</tr>
						</thead>
						<tbody>
						<tr>
								<th scope="row">
								<div className="d-flex">
										<span>{APP_TEXTS.CALCULATE_RESULTS_DESIGN_CONCRETE_BREAKOUT.Content}</span>
										<span>V<sub>cb{!this.props.hasSingleAnchor && ('g')}r</sub></span>
								</div>
								</th>
										<td>
											{this.prepareValue(this.props.hasSingleAnchor ? 
												this.props.selectedItem.Vcbr : 
												this.props.selectedItem.Vcbgr)}
										</td>
										<td>{prepareNum(this.props.selectedItem.BetaV_ConcreteEdgeFailure, true, 2, true)}</td>
						</tr>
						<tr>
								<th scope="row">
								<div className="d-flex">
										<span>{APP_TEXTS.CALCULATE_RESULTS_DESIGN_PRYOUT_STRENGTH.Content}</span>
										<span>
											V
											<sub>
												cp{!this.props.hasSingleAnchor && ('g')}{!this.props.selectedItem.IsChemical && ('r')}
											</sub>
                    					</span>
								</div>
								</th>
								<td>
									{prepareNum(this.props.selectedItem.BetaV_PryoutFailure, true, 2, true) === '***' ? 
										'***' : this.prepareValue(this.props.hasSingleAnchor ? 
												(this.props.selectedItem.IsChemical ? 
												this.props.selectedItem.Vcp : this.props.selectedItem.Vcpr)
												: (this.props.selectedItem.IsChemical ? 
												this.props.selectedItem.Vcpg : this.props.selectedItem.Vcpgr))
                      				}
								</td>
								<td>{prepareNum(this.props.selectedItem.BetaV_PryoutFailure, true, 2, true)}</td>
						</tr>
						<tr>
								<th scope="row">
								<div className="d-flex">
										<span>{APP_TEXTS.CALCULATE_RESULTS_DESIGN_STEEL_STRENGTH.Content}</span>
										<span>V<sub>sar</sub></span>
								</div>
								</th>
										<td>{prepareNum(this.props.selectedItem.BetaV_SteelFailure, true, 2, true) === '***' ? 
											'***' : this.prepareValue(this.props.selectedItem.Vsar)}</td>
										<td>{prepareNum(this.props.selectedItem.BetaV_SteelFailure, true, 2, true)}</td>
						</tr>
						</tbody>
				</Table>
		
				<Table bordered size="sm">
						<tbody>
						<tr>
								<th scope="row">
									<div className="d-flex">
										<span>{APP_TEXTS.CALCULATE_RESULTS_DESGIN_UTILIZATION_EQUATION.Content}</span>
										<span className="utilization">
											&beta;<sub>N</sub><sup>5/3</sup>&nbsp;+&nbsp;&beta;<sub>V</sub><sup>5/3</sup>&nbsp;=
										</span>
									</div>
								</th>
								<td>{prepareNum(this.props.selectedItem.Beta, true, 2, true)}</td>
						</tr>
						</tbody>
				</Table>
				</section>
				)}
		</div>
		);
	}
    
}

const mapState = state => {
  const data = state.selectors.calculate[state.main.appType];

  if (data && data.gridSelectedItem) {
		let hasSingleAnchor = false;
		if (data.gridSelectedItem.AnchorResults)
			hasSingleAnchor = data.gridSelectedItem.AnchorResults.length === 1 ? true : false;

		return {
			selectedItem: data.gridSelectedItem,
			loadUnit: state.main.units.load,
			hasSingleAnchor
		};
  }

  return {};
};
  
const mapDispatch = dispatch => ({
});
  
export default connect(mapState, mapDispatch)(ResultsOfDesignCSA);



// WEBPACK FOOTER //
// ./src/views/Calculate/components/CalculateResultsOfDesign/components/ResultsOfDesignCSA.js